import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'shared-animated-bar',
  templateUrl: './animated-bar.component.html',
  styleUrls: ['./animated-bar.component.scss'],
})
export class AnimatedBarComponent implements OnInit {
  @Input() linear: boolean = false;

  readonly contextLength = [].constructor(30);

  constructor(private router: Router) {}

  ngOnInit(): void {}

  goToBlackFriday() {
    this.router.navigateByUrl('/category/67/Black-Friday');
  }
}
